import { render, staticRenderFns } from "./ValidationPanel.vue?vue&type=template&id=567629fc"
import script from "./ValidationPanel.vue?vue&type=script&lang=js"
export * from "./ValidationPanel.vue?vue&type=script&lang=js"
import style0 from "./ValidationPanel.vue?vue&type=style&index=0&id=567629fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports